import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { ClientSidePermissionRoleLinkContainerModel } from "blg-akaun-ts-lib";

export interface ClientSideViewModel {
  guid: string;
  perm_code: string;
}
export interface ClientSidePermissionsState extends EntityState<ClientSideViewModel>{
  selectedEntity: ClientSidePermissionRoleLinkContainerModel,
  requiresUpdate: boolean;
}

export const clientSidePermissionsAdapter = createEntityAdapter<ClientSideViewModel>({
  selectId: model => model.guid.toString()
});

export const initialClientSidePermissionsState = clientSidePermissionsAdapter.getInitialState({
  selectedEntity: null,
  requiresUpdate: false
});
